// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getLaborAdditivePipsSummary} from '../../shared/repositories';

export const readLaborAdditiveSummaries = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborAdditivePipsSummary();

            dispatch({
                data,
                type: actions.READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARIES_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/labor-additive-summaries.js